var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('dashboard-core-app-bar'),(_vm.user)?_c('dashboard-core-drawer'):_vm._e(),_c('dashboard-core-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }